module.exports = __webpack_public_path__ + "static/media/CheckSelectionScreen.b53ce1a2.png";